import { urls } from '@consts';

export const SnowflakeReportContainer = () => {
  window.location.replace(urls.SnowflakeReport);
  return null;
};

export default SnowflakeReportContainer;